module.exports = __webpack_public_path__ + "img/1728956136768-Screenshot_15-10-2024_93514_.jpeg.950172b5.webp";